import { Span } from 'opentracing';
import { extractWebgateInfo } from './TracedFetch';

type ServiceName = string;
type ServiceOwner = string;
type ServiceTribe = string;
type ServiceOwnership = {
  owner: ServiceOwner;
  tribe: ServiceTribe;
};

// TODO: extract/centralize this so it's not buried in the platform and can be
// shared with other ownership initiatives.
const requestOwnership = new Map<ServiceName, ServiceOwnership>();
requestOwnership.set('activity-feed', {
  owner: 'alohomora',
  tribe: 'creator-core',
});
requestOwnership.set('canvaz-view', {
  owner: 'imagine',
  tribe: 'creator-studio',
});
requestOwnership.set('buyerxp-campaign-view', {
  owner: 'buyer-experience',
  tribe: 'creator-studio',
});
requestOwnership.set('creator-auth-proxy', {
  owner: 'bedrock-squad',
  tribe: 'creator-core',
});
requestOwnership.set('creator-search-service', {
  owner: 'bedrock-squad',
  tribe: 'creator-core',
});
requestOwnership.set('hyperlink', {
  owner: 'hype',
  tribe: 'creator-studio',
});
requestOwnership.set('marketplace-mgmt', {
  owner: 'alohomora',
  tribe: 'creator-core',
});
requestOwnership.set('marquee-assistant', {
  owner: 'elevate-promo',
  tribe: 'creator-studio',
});
requestOwnership.set('marquee-forecaster', {
  owner: 'elevate-promo',
  tribe: 'creator-studio',
});
requestOwnership.set('nms-form', {
  owner: 's4a-stardust',
  tribe: 's4x',
});
requestOwnership.set('nms-form-data', {
  owner: 's4a-stardust',
  tribe: 's4x',
});
requestOwnership.set('nms-submission', {
  owner: 's4a-stardust',
  tribe: 's4x',
});
requestOwnership.set('roster-view-service', {
  owner: 's4a-stardust',
  tribe: 's4x',
});
requestOwnership.set('s4a-graphql.spotify.com', {
  owner: 'platypus-squad',
  tribe: 'creator-core',
});
requestOwnership.set('s4a-onboarding', {
  owner: 'alohomora',
  tribe: 'creator-core',
});
requestOwnership.set('s4a-service', {
  owner: 'bedrock-squad',
  tribe: 'creator-core',
});
requestOwnership.set('s4x-access', {
  owner: 'imagine',
  tribe: 'creator-studio',
});
requestOwnership.set('s4x-home-service', {
  owner: 'creator-highlights',
  tribe: 's4x',
});
requestOwnership.set('s4x-insights-api', {
  owner: 's4x-understand',
  tribe: 's4x',
});
requestOwnership.set('s4x-me', {
  owner: 'bedrock-squad',
  tribe: 'creator-core',
});
requestOwnership.set('s4x-wallet', {
  owner: 's4x-moneybadger',
  tribe: 'creator-core',
});
requestOwnership.set('sfx-home-shareables', {
  owner: 'creator-highlights',
  tribe: 's4x',
});
requestOwnership.set('sponcerts', {
  owner: 's4a-stardust',
  tribe: 's4x',
});
requestOwnership.set('team-account-settings', {
  owner: 's4x-moneybadger',
  tribe: 'creator-core',
});
requestOwnership.set('upcoming-view-service', {
  owner: 's4a-stardust',
  tribe: 's4x',
});

const OWNERSHIP_OWNER_TAG = 'ownership.owner';
const OWNERSHIP_TRIBE_TAG = 'ownership.tribe';

export function addOwnershipInfo(span: Span, req: Request) {
  const wgInfo = extractWebgateInfo(req);
  if (!wgInfo) return;

  const ownership = requestOwnership.get(wgInfo.service);
  if (!ownership) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(
        `Request to service ${wgInfo.service} did not have tracing ownership information registered.`,
      );
    }

    span.addTags({
      [OWNERSHIP_OWNER_TAG]: 'unknown',
      [OWNERSHIP_TRIBE_TAG]: 'unknown',
    });
    return;
  }

  span.addTags({
    [OWNERSHIP_OWNER_TAG]: ownership.owner,
    [OWNERSHIP_TRIBE_TAG]: ownership.tribe,
  });
}
